module.exports = __webpack_public_path__ + "fonts/BrandonGrotesque-Regular.aba7d125.ttf";